/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loginBg: {
      ...theme.custom.login.loginBg,
    },
    logo: {
      width: 250,
    },
    container: {
      paddingTop: theme.spacing(30),
    },
    box: {
      flexBasis: "0",
      paddingBottom: theme.spacing(30),
      paddingTop: theme.spacing(2),
    },
    loginWrapper: {
      padding: theme.spacing(4),
      maxWidth: "fit-content",
      borderRadius: 10,
      minWidth: theme.spacing(34),
      ...theme.custom.login.loginWrapper,
    },
    tagLineContainer: {
      paddingBottom: theme.spacing(2),
    },
    tagLine: {
      fontSize: 17,
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: theme.spacing(0.2),
      letterSpacing: "normal",
      ...theme.custom.login.tagLine,
    },
    google: {
      width: 264,
      ...theme.custom.login.google,
    },
    github: {
      width: 264,
      ...theme.custom.login.github,
    },
    microsoft: {
      width: 264,
      ...theme.custom.login.microsoft,
    },
    email: {
      width: theme.spacing(33),
      ...theme.custom.login.email,
    },
    enterprise: {
      width: 264,
      ...theme.custom.login.enterprise,
    },
    loginBtn: {
      fontFamily: "Roboto",
      paddingLeft: 8,
      paddingRight: 12,
      height: 40,
      textTransform: "none",
      fontSize: 14,
      fontWeight: 500,
      lineHeight: 1.5,
      borderRadius: 2,
      letterSpacing: 0.22,
      boxShadow: "0 0 1px 0 rgba(0,0,0,0.12), 0 1px 1px 0 rgba(0,0,0,0.24)",
      marginTop: theme.spacing(1.5),
      backgroundColor: theme.palette.common.white,
      whiteSpace: "nowrap",
      "&:hover, &:focus, &:active": {
        backgroundColor: "#EEEEEE",
        boxShadow: "0 0 2px 0 rgba(0,0,0,0.12), 0 2px 2px 0 rgba(0,0,0,0.24)",
      },
      ...theme.custom.login.loginBtn,
    },
    btnIcon: {
      marginLeft: theme.spacing(-4.75),
      marginRight: theme.spacing(3),
      height: theme.spacing(2.25),
      minWidth: theme.spacing(2.25),
    },
    msftBtnIcon: {
      marginRight: theme.spacing(3),
      marginLeft: theme.spacing(-2.75),
      height: theme.spacing(2.25),
      minWidth: theme.spacing(2.25),
    },
    enterpriseBtnIcon: {
      marginRight: theme.spacing(3),
      height: theme.spacing(2.25),
      minWidth: theme.spacing(2.25)
    },
    btnContainer: {
      marginTop: theme.spacing(2),
    },
    msgContainer: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(3),
      paddingLeft: theme.spacing(1.5),
    },
    successMsg: {
      color: theme.palette.common.white,
      display: "inline",
      fontSize: "15px",
      ...theme.custom.login.successMsg,
    },
    contentContainer: {
      marginTop: theme.spacing(4),
    },
    logoTitle: {
      color: theme.palette.common.white,
      flexGrow: 1,
      paddingLeft: "15px",
      paddingRight: "15px",
      fontWeight: "bold",
      textAlign: "left",
      fontSize: "25px",
      lineHeight: 1.55,
      ...theme.custom.login.logoTitle,
    },
    divider: {
      backgroundColor: theme.palette.common.white,
      marginLeft: "15px",
      ...theme.custom.login.divider,
    },
    enterpriseAlign: {
      marginLeft: theme.spacing(-2),
    },
    emailBtnIcon: {
      margin: theme.spacing(0, 2.875, -0.1, -7.8),
      height: theme.spacing(2.25),
      width: theme.spacing(2.25),
    },
    emailIcon: {
      fontSize: theme.spacing(2),
    },
    orDividerText: {
      display: 'flex',
      justifyContent: 'center',
      cursor: 'default',
      marginTop: theme.spacing(1.75),
      color: theme.palette.secondary.main,
    },
  })
);
